module.exports = __webpack_public_path__ + "static/media/SVGEdex.42c910e4.svg";